export default __webpack_public_path__ + "static/media/elevate-dmb-poster-2.d7071775.jpg";